import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from 'axios';
import { api } from '.';
var baseURL = process.env['NX_JOVE_API'];
export function getPromotions(_x) {
  return _getPromotions.apply(this, arguments);
}

function _getPromotions() {
  _getPromotions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryParams) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get(queryParams ? "/promotions?".concat(queryParams.toString()) : '/promotions');

          case 3:
            res = _context.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context.next = 6;
              break;
            }

            throw new Error('No data returned when getting promotions');

          case 6:
            return _context.abrupt("return", {
              data: res.data.data,
              total_count: res.data.total_count
            });

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.error('Error getting promotions', _context.t0);
            return _context.abrupt("return", {
              data: [],
              total_count: 0
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));
  return _getPromotions.apply(this, arguments);
}

export function getPromotion(_x2) {
  return _getPromotion.apply(this, arguments);
}

function _getPromotion() {
  _getPromotion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.get("/promotions/".concat(id));

          case 3:
            res = _context2.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context2.next = 6;
              break;
            }

            throw new Error('No data returned when getting promotion');

          case 6:
            return _context2.abrupt("return", res.data);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            console.error('Error getting promotion', _context2.t0);
            return _context2.abrupt("return", null);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));
  return _getPromotion.apply(this, arguments);
}

export function createPromotion(_x3) {
  return _createPromotion.apply(this, arguments);
}

function _createPromotion() {
  _createPromotion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(promotion) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.post('/promotions', promotion);

          case 3:
            res = _context3.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context3.next = 6;
              break;
            }

            throw new Error('No data returned when creating promotion');

          case 6:
            return _context3.abrupt("return", res.data);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            console.error('Error creating promotion', _context3.t0);
            return _context3.abrupt("return", null);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));
  return _createPromotion.apply(this, arguments);
}

export function updatePromotion(_x4, _x5) {
  return _updatePromotion.apply(this, arguments);
}

function _updatePromotion() {
  _updatePromotion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, promotion) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.patch("/promotions/".concat(id), promotion);

          case 3:
            res = _context4.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context4.next = 6;
              break;
            }

            throw new Error('No data returned when updating promotion');

          case 6:
            return _context4.abrupt("return", res.data);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            console.error('Error updating promotion', _context4.t0);
            return _context4.abrupt("return", null);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));
  return _updatePromotion.apply(this, arguments);
}

export function deletePromotion(_x6) {
  return _deletePromotion.apply(this, arguments);
}

function _deletePromotion() {
  _deletePromotion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
    var res, _error$response, _error$response$data, _error$response$data$;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api["delete"]("/promotions/".concat(id));

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", res.data || {
              ok: true
            });

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            console.error('Error deleting promotion', _context5.t0);
            return _context5.abrupt("return", {
              ok: false,
              error: (_error$response = _context5.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.content) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.params
            });

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));
  return _deletePromotion.apply(this, arguments);
}

export function getBanner(_x7) {
  return _getBanner.apply(this, arguments);
}

function _getBanner() {
  _getBanner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(promotionId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.get("/promotions/".concat(promotionId, "/banner"));

          case 3:
            res = _context6.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context6.next = 6;
              break;
            }

            throw new Error('No data returned when getting banner');

          case 6:
            return _context6.abrupt("return", res.data);

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](0);
            console.error('Error getting banner', _context6.t0);
            return _context6.abrupt("return", null);

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 9]]);
  }));
  return _getBanner.apply(this, arguments);
}

export function uploadBanner(_x8, _x9) {
  return _uploadBanner.apply(this, arguments);
}

function _uploadBanner() {
  _uploadBanner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(file, promotionId) {
    var formData, res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            formData = new FormData();
            formData.append('file', file);
            _context7.next = 5;
            return api.post("/promotions/".concat(promotionId, "/banner"), formData);

          case 5:
            res = _context7.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context7.next = 8;
              break;
            }

            throw new Error('No data returned when uploading banner');

          case 8:
            return _context7.abrupt("return", res.data);

          case 11:
            _context7.prev = 11;
            _context7.t0 = _context7["catch"](0);
            console.error('Error uploading banner', _context7.t0);
            return _context7.abrupt("return", null);

          case 15:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 11]]);
  }));
  return _uploadBanner.apply(this, arguments);
}

export function getAuthenticatedPromotionBySlug(_x10) {
  return _getAuthenticatedPromotionBySlug.apply(this, arguments);
}

function _getAuthenticatedPromotionBySlug() {
  _getAuthenticatedPromotionBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(slug) {
    var res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api.get("/promotions/get_by_slug/".concat(slug));

          case 3:
            res = _context8.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context8.next = 6;
              break;
            }

            throw new Error('No data returned when getting promotion by slug');

          case 6:
            return _context8.abrupt("return", res.data);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](0);
            console.error('Error getting promotion by slug', _context8.t0);
            return _context8.abrupt("return", null);

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 9]]);
  }));
  return _getAuthenticatedPromotionBySlug.apply(this, arguments);
}

export function checkSlugAvailability(_x11) {
  return _checkSlugAvailability.apply(this, arguments);
}

function _checkSlugAvailability() {
  _checkSlugAvailability = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(slug) {
    var res, promotion, isAvailable, _error$response2;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return api.get("/promotions/get_by_slug/".concat(slug));

          case 3:
            res = _context9.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context9.next = 6;
              break;
            }

            throw new Error('No data returned when checking slug availability');

          case 6:
            promotion = res.data;
            isAvailable = promotion.slug !== slug;
            return _context9.abrupt("return", isAvailable);

          case 11:
            _context9.prev = 11;
            _context9.t0 = _context9["catch"](0);

            if (!(((_error$response2 = _context9.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 404)) {
              _context9.next = 15;
              break;
            }

            return _context9.abrupt("return", true);

          case 15:
            console.error('Error checking slug availability', _context9.t0);
            return _context9.abrupt("return", false);

          case 17:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 11]]);
  }));
  return _checkSlugAvailability.apply(this, arguments);
}

export function getPromotionBySlug(_x12) {
  return _getPromotionBySlug.apply(this, arguments);
}

function _getPromotionBySlug() {
  _getPromotionBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(slug) {
    var res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return axios.get("".concat(baseURL, "/promotions/get_valid_by_slug/").concat(slug));

          case 3:
            res = _context10.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context10.next = 6;
              break;
            }

            throw new Error('No data returned when getting promotion by slug');

          case 6:
            return _context10.abrupt("return", res.data);

          case 9:
            _context10.prev = 9;
            _context10.t0 = _context10["catch"](0);
            console.error('Error getting promotion by slug', _context10.t0);
            return _context10.abrupt("return", null);

          case 13:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 9]]);
  }));
  return _getPromotionBySlug.apply(this, arguments);
}

export function getAllPromotionsForQuoteId(_x13) {
  return _getAllPromotionsForQuoteId.apply(this, arguments);
}

function _getAllPromotionsForQuoteId() {
  _getAllPromotionsForQuoteId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(quoteId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return api.get("/promotions/get_valid_promotions_for_quote/".concat(quoteId));

          case 3:
            res = _context11.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context11.next = 6;
              break;
            }

            throw new Error('No data returned when getting all available promotions for quote');

          case 6:
            return _context11.abrupt("return", res.data);

          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11["catch"](0);
            console.error('Error getting all available promotions for quote', _context11.t0);
            return _context11.abrupt("return", {
              data: [],
              total_count: 0
            });

          case 13:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 9]]);
  }));
  return _getAllPromotionsForQuoteId.apply(this, arguments);
}